export default function parseJSONTryCatched(string) {
  try {
    return JSON.parse(string);
  } catch (e) {
    console.log(e);
    return null;
  }
}
